module.exports = __webpack_public_path__ + "img/北理工.faaebfae.png";